// extracted by mini-css-extract-plugin
export default {"container":"ForOrganizationInternationalPool_container__+A4RJ","buttonSection":"ForOrganizationInternationalPool_buttonSection__xcc-7"};